import { useCallback } from "react";
import { TrackingEvents } from "../../events";
import { sendFullStoryEvent } from "../../fullstory/events";
import { useRoomEventListeners } from "../../session/events/useRoomEventListeners";
import type { RoomEventHandlerMap } from "../../video-sdk";
import { useLeaveSessionCallback } from "./useLeaveSessionCallback";
import { useClientParticipantDisconnectedEventHandlerCallback } from "./events/useClientParticipantDisconnectedEventHandlerCallback";

export function useClientRoomEventListeners() {
  const leaveSession = useLeaveSessionCallback();
  const onPageUnload = () => {
    sendFullStoryEvent(TrackingEvents.CLIENT_TAB_CLOSE);
  };
  const handleParticipantDisconnectedEvent =
    useClientParticipantDisconnectedEventHandlerCallback();

  const onRoomDisconnect = useCallback<RoomEventHandlerMap["disconnected"]>(
    (_room, _error, { isRoomRejoinable } = {}) => {
      // rejoin flow - skip leaving session
      if (isRoomRejoinable) {
        return;
      }
      leaveSession();
    },
    [leaveSession],
  );

  useRoomEventListeners({
    onParticipantDisconnect: handleParticipantDisconnectedEvent,
    onRoomDisconnect,
    onPageUnload,
  });
}
